import cn from 'clsx'
import { FC } from 'react'
import SkeletonUI from 'react-loading-skeleton'

import { ISkeleton } from './skeleton.interface'

const Skeleton: FC<ISkeleton> = ({ className }) => {
	return (
		<SkeletonUI
			className={cn('w-full', className)}
			highlightColor='#DEDEE2'
			baseColor='#F2F2F7'
		/>
	)
}

export default Skeleton
